import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MappingComponent } from '../../mapping/mapping.component';
import { Rainfall } from "../../models/rainfall";
import { RainfallClassification } from "../../models/rainfallClassification";

// tslint:disable-next-line:no-duplicate-imports
// @ts-ignore
import _moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
// tslint:disable-next-line:no-duplicate-imports
// @ts-ignore
import { default as _rollupMoment } from 'moment';
import {MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'L',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY-MM-DD',
    dateA11yLabel: 'L',
    monthYearA11yLabel: 'YYYY-MM-DD',
  },
};

@Component({
    selector: 'app-rainfall-capture',
    templateUrl: './rainfall-capture.component.html',
    styleUrls: ['./rainfall-capture.component.css'],
    providers: [{
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class RainfallCaptureComponent implements OnInit {

  name = "";
  rainfall: Rainfall[] = [];
  rainfallClassifications: RainfallClassification[] = [];
  selectedClassification: number;
  rainMeterId;
  date;
  isRainfallEmpty = true;
  public validation_messages;
  public errAmountRequired;
  public errAmountLength;
  public errAmountPattern;
  public errDesRequired;
  public errDesLength;
  public errDateRequired;

  rainfallForm = new FormGroup({
    rainfallAmount: new FormControl('', Validators.compose([
      Validators.required,
      Validators.minLength(1),
      Validators.pattern('^[0-9]+(.[0-9]{0,10})?$')
    ])),
    description: new FormControl(''),
    classification: new FormControl(''),
    captureDate: new FormControl(moment(), Validators.compose([
      Validators.required
    ]))
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<MappingComponent>,
    public translate: TranslateService
  ) {
    this.validation_messages = {
      'rainfallAmount': [
        { type: 'required', message: translate.instant('RAINFALL-CAPTURE-DIALOG.ERROR-AMOUNT-REQUIRED') },
        { type: 'minlength', message: translate.instant('RAINFALL-CAPTURE-DIALOG.ERROR-AMOUNT-LENGTH') },
        { type: 'pattern', message: translate.instant('RAINFALL-CAPTURE-DIALOG.ERROR-AMOUNT-PATTERN') }
      ],
      'description': [
        { type: 'required', message: translate.instant('RAINFALL-CAPTURE-DIALOG.ERROR-DESCRIPTION-REQUIRED') },
        { type: 'minlength', message: translate.instant('RAINFALL-CAPTURE-DIALOG.ERROR-DESCRIPTION-LENGTH') }
      ],
      'captureDate': [
        { type: 'required', message: translate.instant('RAINFALL-CAPTURE-DIALOG.ERROR-CAPTURE-DATE') }
      ]
    }

  }

  ngOnInit(): void {
    if (this.data != null) {
      this.rainMeterId = this.data.rainMeterId;
      this.name = this.data.name;
      this.rainfall = this.data.rainfall;
      if (this.rainfall.length > 0) {
        this.isRainfallEmpty = false;
      }
      this.rainfallClassifications = this.data.rainfallClassifications;
      if (this.rainfallClassifications.length > 0) {
        this.date = moment(new Date(), "YYYY-MM-DD");
        this.rainfallForm.setValue({ rainfallAmount: "", description: "", classification: this.rainfallClassifications[0].name, captureDate: this.date});
      }
    }
  }

  dateChanged(event: MatDatepickerInputEvent<Date>) {
    this.date = event.value;
  }

  onSubmit() {
    let amount = this.rainfallForm.controls.rainfallAmount.value;
    let description = this.rainfallForm.controls.description.value;
    let classification = this.rainfallForm.controls.classification.value;

    let classificationId = -1;

    this.rainfallClassifications.forEach(classif => {
      if (classif.name == classification) {
        classificationId = classif.id;
      }
    })

    let rainfall = {
      "rainfall": amount,
      "description": description,
      "classification": classificationId,
      "dateCaptured": this.date.format("YYYY-MM-DD"),
      "rainMeterId": this.rainMeterId
    };

    this.dialogRef.close({ "rainfall": rainfall });
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
